<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingInvoice"
  >

  <AtomButtonSecondary
    :button-secondary="buttonSecondary.download"
  />

  <AtomButtonSecondary
    :button-secondary="buttonSecondary.print"
    @print="print"
  />

  <AtomButtonSecondary
    :button-secondary="buttonSecondary.refund"
  />

  <!-- comprobante -->
  <div class="comprobante">
    <div class="comprobante-header">
      <div class="comprobante-header-logo"></div>
      <div class="comprobante-header-data-empresa">
        <ul>
          <li><span class="font-weight-regular">Apellido y Nombre</span></li>
          <li><span>DNI: 123456789</span></li>
          <li><span>Dirección, Nombre de la Calle, Numeración 143</span></li>
          <li><span>Provincia, País</span></li>
          <li><span>Teléfono: 09923311645</span></li>
        </ul>
      </div>
      <div class="comprobante-header-data-numeracion">
        <ul>
          <li><span class="data-name">Nº Factura:</span> <span class="data-value">01</span></li>
          <li><span class="data-name">Creación:</span> <span class="data-value">2018/11/11</span></li>
          <li><span class="data-name">Medio de Pago:</span> <span class="data-value">Transferencia Bancaria</span></li>
          <li><span class="data-name">Estado:</span> <span class="data-value">Cobrado</span></li>
        </ul>
      </div>
    </div>
    <div class="comprobante-data-cliente">
      <div class="comprobante-data-cliente-titulo">
        <h2>Cliente</h2>
      </div>
      <div class="comprobante-data-cliente-setizq">
        <ul>
          <li><span class="data-name">DNI:</span> <span class="data-value">987654321</span></li>
          <li><span class="data-name">Cliente:</span> <span class="data-value">Nombre y Apellido</span></li>
          <li><span class="data-name">Dirección:</span> <span class="data-value">Nombre de la Calle, Numeración 431</span></li>
          <li><span class="data-name">Código Postal:</span> <span class="data-value">222</span></li>
          <li><span class="data-name">E-mail:</span> <span class="data-value">cliente@email.com</span></li>
        </ul>
      </div>
      <div class="comprobante-data-cliente-setder">
        <ul>
          <li><span class="data-name">País:</span> <span class="data-value">Argentina</span></li>
          <li><span class="data-name">Provincia:</span> <span class="data-value">San Juan</span></li>
          <li><span class="data-name">Localidad:</span> <span class="data-value">San Juan</span></li>
          <li><span class="data-name">Teléfono:</span> <span class="data-value">055889036</span></li>
          <li><span class="data-name">Móvil:</span> <span class="data-value">055889039</span></li>
        </ul>
      </div>
    </div>
    <div class="comprobante-data-items">
      <table>
        <tr>
          <th width="60%" class="text-align-left">ITEM</th>
          <th width="20%" class="text-align-right">PRECIO UNITARIO</th>
          <th width="10%" class="text-align-center">UNIDADES</th>
          <th width="10%" class="text-align-right">SUBTOTAL</th>
        </tr>
        <tr>
          <td class="text-align-left">Nombre del item que se vendió</td>
          <td class="text-align-right">0.5US$</td>
          <td class="text-align-center">1</td>
          <td class="text-align-right">0.5US$</td>
        </tr>
      </table>
    </div>
    <div class="comprobante-data-total">
      <table>
        <tr>
          <td width="90%" class="text-align-right">Subtotal</td>
          <td width="10%" class="text-align-right">0.5US$</td>
        </tr>
        <tr>
          <td width="90%" class="text-align-right">Impuestos (IVA)</td>
          <td width="10%" class="text-align-right">21%</td>
        </tr>
        <tr>
          <td width="90%" class="text-align-right font-weight-bold">Total</td>
          <td width="10%" class="text-align-right font-weight-bold">0.61US$</td>
        </tr>
      </table>
    </div>
  </div>
  <!-- fin comprobante -->

  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMyChargesInvoice',

  data () {
    return {
      buttonSecondary: {
        download: {
          class: 'a-button-billing-secondary a-button-side',
          component: '',
          icon: 'fas fa-download',
          method: '',
          text: 'Descargar',
          type: 'button'
        },

        print: {
          class: 'a-button-billing-secondary a-button-side',
          component: '',
          icon: 'fas fa-print',
          method: 'print',
          text: 'Imprimir',
          type: 'button'
        },

        refund: {
          class: 'a-button-billing-secondary a-button-side',
          component: '',
          icon: 'fas fa-undo-alt',
          method: '',
          text: 'Reembolsar',
          type: 'button'
        }
      },

      showLoadingState: false
    }
  },

  methods: {
    print () {
      window.print()
    }
  }
}
</script>
